import { captureMessage } from '#lib/sentry';

/**
 * Soft-validates data against a Zod schema without throwing on errors.
 * Always returns the original data unchanged.
 *
 * - Development: Logs a console.warn on schema mismatch
 * - Production: Sends a captureMessage to Sentry
 *
 * @param {import('zod').ZodSchema} schema - Zod schema for validation
 * @param {unknown} data - Data to validate
 * @param {string} label - Human-readable label for logging (e.g. "orgInfo")
 * @returns {unknown} The original data, unchanged
 */
export function validateResponse(schema, data, label) {
	const result = schema.safeParse(data);

	if (!result.success) {
		const message = `[Schema Mismatch] ${label}: ${result.error.message}`;

		if (process.env.NODE_ENV !== 'development') {
			captureMessage(message, {
				tags: { section: 'schema-validation', label },
				extra: { issues: result.error.issues },
				level: 'warning',
			});
		}
	}

	return data;
}
